import { render, staticRenderFns } from "./VehiculoOperaciones.vue?vue&type=template&id=6181d8c4&"
import script from "./VehiculoOperaciones.vue?vue&type=script&lang=js&"
export * from "./VehiculoOperaciones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports